import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'ngx-dialog',
    styleUrls: ['./pdf-dialog.component.scss'],
    templateUrl: './pdf-dialog.component.html',
    standalone: false
})
export class PdfDialogComponent {

  @Input() url: string;
  @Output() isClosed = new EventEmitter<boolean>(false);

  constructor(private sanitizer: DomSanitizer) { }

  getUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }
  
  cancel() {
    this.isClosed.emit(true);
  }
}
